export const APP_TITLE = 'デュエプレ 非公式カードリスト'

export const CONTACT_FORM_URL =
  'https://docs.google.com/forms/d/e/1FAIpQLSfCjuduiYLQOe-_ax76imkAOOLLdMUihMqRcRI7c3S9gbiZQg/viewform'
